import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 20l0 -10","key":"svg-0"}],["path",{"d":"M12 20l4 -4","key":"svg-1"}],["path",{"d":"M12 20l-4 -4","key":"svg-2"}],["path",{"d":"M4 4l16 0","key":"svg-3"}]]

const IconArrowBarDown = createReactComponent('outline', 'arrow-bar-down', 'ArrowBarDown', __iconNode);

export default IconArrowBarDown;